import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { StateMap, UnitOfWork, UserManager } from '../../services/common';
import { Announcement } from '../../entities/EntityModels';

import {Observable, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'whats-new',
    templateUrl: './whats-new.html'
})
export class WhatsNewComponent implements OnInit {

    _announcements: Announcement[];
    _documentManagementUrl: string;
    _isLoading = false;
    _validationMessage: string;

    constructor(public _uow: UnitOfWork, public _stateMap: StateMap, public _userManager: UserManager, private _httpClient: HttpClient, public _sanitizer: DomSanitizer) {

    }

    ngOnInit() {
        this._uow.announcementRepository.all().then(r => {
            this._announcements = _.orderBy(r, a => a.announcementDate, 'desc');
        });

        this._uow.getDocumentManagementUrl().then(url => {
            this._stateMap.documentManagementBaseUrl = url;
            this._documentManagementUrl = this._stateMap.documentManagementBaseUrl  + '/RIFMDownloadableFile';
        });
    }

    isStaff() {
        return this._stateMap.currentUser.isStaff;
    }

    linkTo(e: Announcement) {
        let url: string;
        const webLink = e.webLink;
        if (webLink.startsWith('http')) {
            url = webLink;
            window.open(url, '_self');
            return false;
        }

        const fileParts = this.splitFileData(webLink);
        if (fileParts) {
            return (this.exportContentFile(fileParts[1], fileParts[0]));
        }
    }

    splitFileData(data: string) {
        if (!this.isValidString(data)) {
            return null;
        }
        const fileParts = data.split('\\');
        if (fileParts != null && fileParts.length == 2) {
            return fileParts;
        }
        return null;
    }

    isValidString(teststring: string) {
        if (!teststring) { return false; }

        return (teststring.trim().length > 0);
    }

    retrieveSafeHTML(data: string) {
        return this._sanitizer.bypassSecurityTrustHtml(data);
    }

    // ************************************************************************
    // document management web api url
    // ************************************************************************
    getDownloadFileURL(fileName: string, subFolder: string): Observable<any> {
        let url: string;
        url = this._documentManagementUrl + '/GetFileBySubFolderAndName?fileName=' + fileName + '&subFolder=' + subFolder ;

        return this._httpClient.get<any>(url, { responseType: 'blob' as 'json'});
    }

    public exportContentFile(fileName: string, subFolder: string) {
        this._isLoading = true;
        this._validationMessage = '';
        this.getDownloadFileURL(fileName, subFolder)
            .subscribe(
                (response: Blob) => {
                    const data = response;

                    const file = new Blob([data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);

                    // window.open(fileURL);
                    const a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = fileName;
                    document.body.appendChild(a);
                    a.click();

                    a.remove();

                    window.URL.revokeObjectURL(fileURL);

                    this._validationMessage = 'File download successful.';

                },
                (error) => {
                    console.error('Request failed with error: ' + error.message);
                    this._validationMessage = error.message;
                    this._isLoading = false;
                },
                () => {
                    this._isLoading = false;
                });
    }
}
